import { store } from "../app/store";
export const getAuthorizationHeader = () => {
  const token = store.getState().auth.token;
  return { Authorization: `Bearer ${token}` };
};
